import React, { useEffect } from "react";
import { useModal } from "../contexts/ModalContext";

export default function Modal() {
  const { modalState, modalDispatch } = useModal();

  useEffect(() => {
    window.scrollTo(0, 0);
    let timer = setTimeout(() => {
      modalDispatch({ type: "CLOSE_MODAL" });
    }, modalState.modalText.length * 50);
    return () => {
      clearTimeout(timer);
      //modalDispatch({ type: "CLOSE_MODAL" });
    };
  });
  return (
    <div className={modalState.modalIsError ? "modal error-box" : "modal success-box"}>
      {modalState.modalText}
    </div>
  );
}
